"use strict";

var _classCallCheck = require("/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * LoadersRegistry
 * loaders can define a static priority number. more high is priority, more important the loader is to be used first.
 */


var LoadersRegistry =
/*#__PURE__*/
function () {
  function LoadersRegistry() {
    _classCallCheck(this, LoadersRegistry);

    _defineProperty(this, "_loaders", []);
  }
  /**
   * Add a TextureLoader class to extend texture format support.
   */


  _createClass(LoadersRegistry, [{
    key: "add",
    value: function add(loader) {
      this._loaders.push(loader);

      this._loaders.sort(function (a, b) {
        return (// $FlowFixMe
          (typeof b.priority === "number" ? b.priority : 0) - ( // $FlowFixMe
          typeof a.priority === "number" ? a.priority : 0)
        );
      });
    }
    /**
     * Remove a previously added WebGLTextureLoader class.
     */

  }, {
    key: "remove",
    value: function remove(loader) {
      var i = this._loaders.indexOf(loader);

      if (i !== -1) {
        this._loaders.splice(i, 1);
      }
    }
    /**
     * List the loaders ordered by most priority first
     */

  }, {
    key: "get",
    value: function get() {
      return this._loaders;
    }
  }]);

  return LoadersRegistry;
}();

exports.default = LoadersRegistry;